/**
* Utility function to calculate the current theme setting.
* Look for a local storage value.
* Fall back to system setting.
* Fall back to light mode.
*/

function calculateSettingAsThemeString({ localStorageTheme, systemSettingDark }) {
  if (localStorageTheme !== null) {
    return localStorageTheme;
  }

  if (systemSettingDark.matches) {
    return "dark";
  }

  return "light";
}

/**
* Utility function to update the theme setting on the html tag
*/
function updateThemeOnHtmlEl({ theme }) {
  document.querySelector("html").setAttribute("data-theme", theme);

  let darkModeSwitch = document.querySelectorAll('.dark_mode_switch input');
  darkModeSwitch.forEach(switchitem => {
    if(theme === "dark")
    {
      switchitem.checked = true;
    }
  });
}

/**
* On page load:
*/

/**
* 1. Grab what we need from the DOM and system settings on page load
*/
const button = document.querySelector("[data-theme-toggle]");
const localStorageTheme = localStorage.getItem("theme");
const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");

/**
* 2. Work out the current site settings
*/
let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme, systemSettingDark });
/**
 

* 3. Add any elements that need to be styled manually to the array
*/
const customDarkModeElements = [...document.querySelectorAll(
  '.bg-colour-white, .main-collection-container, .header__icons, .image-link-grid-section-block--button-container, .button--primary, .button--secondary, .product-card--button-container, .trustpilot-section, .search-modal--mobile, .product__info-wrapper, .product__media-wrapper, .add-to-cart-bar, .cart-notification, .main-cart, .blog, .product-media-modal__dialog, .price-per-item__container, .product-slider--product-card-list, .quantity__button, .mega-menu__content--image-grid, hr, .product-bundle-container'
)];

assignThemeModeClasses(customDarkModeElements, currentThemeSetting);

/**
* 4. Update the theme setting and button text accoridng to current settings
*/
updateThemeOnHtmlEl({ theme: currentThemeSetting });

/**
* 5. Add an event listener to toggle the theme
*/
const sliders = document.querySelectorAll('[data-theme-toggle]');

sliders.forEach(slider => {
  const themeToggle = slider.previousElementSibling;
  themeToggle.addEventListener('change', () => {
    const newTheme = currentThemeSetting === "dark" ? "light" : "dark";

    localStorage.setItem("theme", newTheme);
    updateThemeOnHtmlEl({ theme: newTheme });

    assignThemeModeClasses(customDarkModeElements, newTheme);

    currentThemeSetting = newTheme;
  });
});

/**
 * Add classes so we can manually style them 
 */
function assignThemeModeClasses(elements, theme)
{
    elements.forEach(element => {
        element.classList.remove('theme-dark');
        element.classList.remove('theme-light');
        element.classList.add(`theme-${theme}`);        
    });
}
